export default __webpack_public_path__ + "static/media/edit-account.034e9328.svg";